import React from 'react';
import { 
  List, 
  ListItem, 
  ListItemText, 
  ListItemIcon, 
  Typography, 
  Box, 
  makeStyles,
  Button,
  Chip
} from '@material-ui/core';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import AnnouncementRoundedIcon from '@material-ui/icons/AnnouncementRounded';
import { useNotifications } from 'services/providers/notification-provider';
import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');

const useStyles = makeStyles((theme) => ({
  unread: {
    backgroundColor: theme.palette.action.hover,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
  read: {
    opacity: 0.8,
  },
  iconSuccess: { color: theme.palette.primary.main },
  iconError: { color: theme.palette.error.main },
  iconInfo: { color: theme.palette.info.main },
  iconRelease: { color: theme.palette.secondary.main },
  chip: {
    height: 16,
    fontSize: '0.6rem',
    marginLeft: theme.spacing(1),
    verticalAlign: 'middle'
  }
}));

export default function NotificationPanel({ onClose }) {
  const classes = useStyles();
  const { notifications, markAsRead, clearAll } = useNotifications();

  const getIcon = (notif) => {
    if (notif.notification_type === 'RELEASE') {
        return <AnnouncementRoundedIcon className={classes.iconRelease} />;
    }
    switch (notif.status) {
      case 'SUCCESS': return <CheckCircleRoundedIcon className={classes.iconSuccess} />;
      case 'FAILURE': return <ErrorRoundedIcon className={classes.iconError} />;
      default: return <InfoRoundedIcon className={classes.iconInfo} />;
    }
  };

  if (notifications.length === 0) {
    return (
      <Box p={4} textAlign="center">
        <Typography color="textSecondary">Aucune notification</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <List disablePadding style={{ maxHeight: 400, overflowY: 'auto' }}>
        {notifications.map((notif) => (
          <ListItem 
            key={notif.id} 
            button 
            divider 
            onClick={() => {
              if (!notif.is_read) markAsRead(notif.id);
            }}
            className={notif.is_read ? classes.read : classes.unread}
          >
            <ListItemIcon>
              {getIcon(notif)}
            </ListItemIcon>
            <ListItemText 
              primary={
                <>
                  {notif.title}
                  {notif.notification_type === 'RELEASE' && (
                    <Chip label="Annonce" size="small" className={classes.chip} color="secondary" />
                  )}
                </>
              }
              secondary={
                <>
                  <Typography variant="body2" component="span" display="block" style={{ whiteSpace: 'pre-wrap' }}>
                    {notif.message}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {moment(notif.created_at).fromNow()}
                  </Typography>
                </>
              }
            />
          </ListItem>
        ))}
      </List>
      <Box p={1} textAlign="center">
        <Button 
            size="small" 
            startIcon={<DeleteRoundedIcon />} 
            onClick={clearAll}
            style={{ textTransform: 'none' }}
            title="Supprime uniquement les notifications de tâches lues"
        >
          Nettoyer mes tâches
        </Button>
      </Box>
    </Box>
  );
}
